"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBanxStakingAccounts = void 0;
const helpers_1 = require("../../helpers");
const helpers_2 = require("../../helpers");
const getBanxStakingAccounts = (programId, connection) => __awaiter(void 0, void 0, void 0, function* () {
    const program = yield (0, helpers_2.returnAnchorProgram)(programId, connection);
    const banxStakesRaw = yield program.account.banxStake.all();
    const banxStakes = banxStakesRaw.map((acc) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(acc));
    const banxTokenStake = (yield program.account.banxTokenStake.all()).map((raw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(raw));
    const adventures = (yield program.account.banxAdventure.all()).map((raw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(raw));
    const adventureSubscriptions = (yield program.account.banxAdventureSubscription.all()).map((raw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(raw));
    const stakingSettingsAccounts = (yield program.account.banxStakingSettings.all()).map((raw) => (0, helpers_1.anchorRawBNsAndPubkeysToNumsAndStrings)(raw));
    return {
        banxStakes,
        banxTokenStake: banxTokenStake,
        adventures,
        adventureSubscriptions,
        stakingSettings: stakingSettingsAccounts[0],
    };
});
exports.getBanxStakingAccounts = getBanxStakingAccounts;
